<template>
  <div>
    <div class="blur-mask-container">
      <svg
        class="blur-svg-mask"
        width="100%"
        height="100%"
        viewBox="0 0 640 480"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <mask :id="maskId">
            <rect
              width="100%"
              height="100%"
              fill="white"
            />
            <ellipse
              cx="50%"
              cy="50%"
              :rx="ovalRadiusX"
              :ry="ovalRadiusY"
              fill="black"
            />
          </mask>
        </defs>
        <rect
          width="100%"
          height="100%"
          fill="rgba(0,0,0,0.4)"
          :mask="`url(#${maskId})`"
          class="blur-rect"
        />
      </svg>
    </div>

    <div
      class="face-guide-frame"
      :class="[
        isMobile ? 'mobile-oval' : 'desktop-oval',
        { 'face-detected': faceDetected }
      ]"
    />
  </div>
</template>

<script>
export default {
  name: 'FaceGuideOverlay',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    faceDetected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maskId() {
      return this.isMobile ? 'ovalMaskMobile' : 'ovalMaskDesktop'
    },
    ovalRadiusX() {
      return this.isMobile ? 120 : 140
    },
    ovalRadiusY() {
      return this.isMobile ? 150 : 175
    },
  },
}
</script>

<style scoped>
.blur-mask-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  pointer-events: none;
}

.blur-svg-mask {
  width: 100%;
  height: 100%;
}

.blur-rect {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.face-guide-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 15;
  background: transparent;
  transition: border-color 0.3s ease;
}

.desktop-oval {
  width: 280px;
  height: 350px;
  border: 4px solid #2196f3;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(255,255,255,0.5), 0 0 10px rgba(33,150,243,0.7);
}

.desktop-oval.face-detected {
  border-color: #28a745;
  border-width: 5px;
  box-shadow: 0 0 0 2px rgba(255,255,255,0.5), 0 0 15px rgba(40,167,69,0.7);
  animation: pulse-border 1.5s infinite;
}

.mobile-oval {
  width: 200px;
  height: 250px;
  border: 5px solid #2196f3;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(255,255,255,0.7), 0 0 15px rgba(33,150,243,0.9);
}

.mobile-oval.face-detected {
  border-color: #28a745;
  border-width: 6px;
  box-shadow: 0 0 0 3px rgba(255,255,255,0.7), 0 0 20px rgba(40,167,69,1);
  animation: pulse-border-mobile 1.5s infinite;
}

@keyframes pulse-border {
  0% { box-shadow: 0 0 0 2px rgba(255,255,255,0.5), 0 0 10px rgba(40,167,69,0.7); }
  50% { box-shadow: 0 0 0 2px rgba(255,255,255,0.7), 0 0 20px rgba(40,167,69,1); }
  100% { box-shadow: 0 0 0 2px rgba(255,255,255,0.5), 0 0 10px rgba(40,167,69,0.7); }
}

@keyframes pulse-border-mobile {
  0% { box-shadow: 0 0 0 3px rgba(255,255,255,0.7), 0 0 15px rgba(40,167,69,0.8); }
  50% { box-shadow: 0 0 0 3px rgba(255,255,255,0.9), 0 0 25px rgba(40,167,69,1); }
  100% { box-shadow: 0 0 0 3px rgba(255,255,255,0.7), 0 0 15px rgba(40,167,69,0.8); }
}

@media (max-width: 576px) {
  .face-guide-frame {
    width: 180px;
    height: 220px;
    border-width: 4px;
    border-color: rgba(33, 150, 243, 0.9);
    box-shadow: 0 0 0 2px rgba(255,255,255,0.5), 0 0 8px rgba(33,150,243,0.8);
  }
}
</style>
